import React, { useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import GroupChannelListHeader from '@sendbird/uikit-react/GroupChannelList/components/GroupChannelListHeader';

import { GroupChannelList } from '@sendbird/uikit-react/GroupChannelList';
import {
  getPatientConversationChannelsSelector,
  getUnreadCount,
  setChannel
} from 'store/patientConversation/patientConversation.redux';
import { GroupChannelListItem } from '@sendbird/uikit-react/GroupChannelList/components/GroupChannelListItem';
import { classNames } from 'shared/utils/class-names';
import { channelTypeMapping } from 'shared/constants/channel';
import {
  getAppConfigSelector,
  getWhiteLabelAffiliateSelector
} from 'store/app/app.redux';
import { getUserSelector } from 'store/user/user.redux';
import {
  CURRENT_AFFILIATE,
  getItemFromLocalStorage
} from 'shared/utils/local-storage';
import { useIntegrations } from 'shared/utils/hooks/integrations';
import {
  INTEGRATION_TYPES,
  INTEGRGATION_STATUS
} from 'shared/constants/integrations';
import IntercomCard from './IntercomCard';

const Submenu: React.FC = () => {
  const dispatch = useDispatch();
  const [selectedChannel, setSelectedChanel] = useState('');
  const affiliateConfig = useSelector(getAppConfigSelector);
  const user = useSelector(getUserSelector);
  const patientConversation = useSelector(
    getPatientConversationChannelsSelector
  );
  const whiteLabelAffiliate = useSelector(getWhiteLabelAffiliateSelector);
  const intergrationClient = useIntegrations();
  const { enabledIntegrations, doAction } = intergrationClient;

  const affiliateChats = useMemo(() => {
    const chats = ['clinical'];
    const currentAffiliate = getItemFromLocalStorage(CURRENT_AFFILIATE);
    const affiliate = user?.patient?.affiliates.find(
      (affiliate) => affiliate.id === currentAffiliate
    );

    if (affiliate?.id && whiteLabelAffiliate?.affiliateChatSystem) {
      if (
        whiteLabelAffiliate?.affiliateChatSystemEnabledChats?.includes(
          'billing'
        )
      ) {
        chats.push('billing');
      }
      if (
        whiteLabelAffiliate?.affiliateChatSystemEnabledChats?.includes(
          'support'
        )
      ) {
        chats.push('support');
      }
    }
    const intercomIntegration = enabledIntegrations.find(
      (integrationConfig) => {
        return (
          integrationConfig.integration.title === INTEGRATION_TYPES.INTERCOM &&
          integrationConfig.status === INTEGRGATION_STATUS.ACTIVE
        );
      }
    );
    if (intercomIntegration) {
      chats.push('intercom_customer_support');
    }
    return chats;
  }, [user, enabledIntegrations.length]);

  // CRUCIAL TO MAKE SURE THAT <App/> renders, otherwise it will crash and chats won't render
  if (!patientConversation) return null;

  return (
    <div className="groupChannelList">
      <GroupChannelList
        onChannelCreated={() => null}
        onChannelSelect={() => null}
        channelListQueryParams={{
          includeEmpty: true,
          customTypesFilter: affiliateChats
        }}
        disableAutoSelect
        allowProfileEdit={false}
        renderChannelPreview={({ channel }) => {
          return (
            <div
              className={classNames({
                [channel.customType]: true,
                'custom-channel': true
              })}
            >
              <GroupChannelListItem
                channel={
                  {
                    ...channel,
                    coverUrl: affiliateConfig?.smallLogo,
                    name:
                      channelTypeMapping[channel.customType]?.name ||
                      channel.name
                  } as typeof channel
                }
                tabIndex={channelTypeMapping[channel.customType]?.index}
                onClick={() => {
                  dispatch(setChannel(channel.url));
                  dispatch(getUnreadCount());
                  setSelectedChanel(channel.customType);
                }}
                isSelected={channel.customType === selectedChannel}
                renderChannelAction={() => <></>}
              />
            </div>
          );
        }}
        renderHeader={() => (
          <GroupChannelListHeader renderRight={() => <></>} />
        )}
      />
      {affiliateChats.indexOf('intercom_customer_support') > -1 && (
        <IntercomCard
          onClick={() => {
            doAction(INTEGRATION_TYPES.INTERCOM, 'open_chat', {});
          }}
        />
      )}
    </div>
  );
};

export default Submenu;
